import bigFish from './../../../image/Rolls/firm/bigFish.webp'
import maguro from './../../../image/Rolls/firm/maguro.webp'
import rollTaho from './../../../image/Rolls/firm/rollTaho.webp'
import filadelfiaClassic from './../../../image/Rolls/firm/filadelfiaClassic.webp'
import sumoSan from './../../../image/Rolls/hot/sumoSan.webp'
import mrCrabs from './../../../image/Rolls/hot/mrCrabs.webp'
import american from './../../../image/Rolls/hot/american.webp'
import kokoVShineli from './../../../image/Rolls/hot/kokoVShineli.webp'
import tibet from './../../../image/Rolls/hot/tibet.webp'
import furai from './../../../image/Rolls/hot/furai.webp'
import filaHot from './../../../image/Rolls/hot/filaHot.webp'
import shimpRoll from './../../../image/Rolls/hot/shimpRoll.webp'
import fudzi from './../../../image/Rolls/backed/fudzi.webp'
import rollDonBekon from './../../../image/Rolls/backed/rollDonBekon.webp'
import hodaiko from './../../../image/Rolls/backed/hodaiko.webp'
import vulkan from './../../../image/Rolls/backed/vulkan.webp'
import spaisiTunec from './../../../image/Rolls/classic/spaisiTunec.webp'
import cheez from './../../../image/Rolls/classic/cheez.webp'
import spaisiMidii from './../../../image/Rolls/classic/spaisiMidii.webp'
import slivochniiTunec from './../../../image/Rolls/classic/slivochniiTunec.webp'
// import maguro from './../../../image/Rolls/backed'

export const images = {
    bigFish: bigFish,
    maguro: maguro,
    rollTaho: rollTaho,
    filadelfiaClassic: filadelfiaClassic,
    sumoSan:sumoSan,
    mrCrabs:mrCrabs,
    american:american,
    kokoVShineli:kokoVShineli,
    tibet:tibet,
    furai:furai,
    filaHot:filaHot,
    shimpRoll:shimpRoll,
    fudzi:fudzi,
    rollDonBekon:rollDonBekon,
    hodaiko:hodaiko,
    vulkan:vulkan,
    spaisiTunec:spaisiTunec,
    cheez:cheez,
    spaisiMidii:spaisiMidii,
    slivochniiTunec:slivochniiTunec,


}